import React from 'react';
import styles from 'styles/button.module.scss';
import loadable from '@loadable/component'
import PropTypes from 'prop-types';
import styled from 'styled-components';
import classNames from 'lib/classNames';
const Icon = loadable(() => import('components/Icon'));

const StyledButton = styled.button`
	&:hover,
	&:active {
		background: ${(props) => props.hover_background || ''} !important;
	}
`;

const iconSizes = {
	default: 'lg',
	small: 'sm',
	medium: '1x',
};

const Button = (props) => {
	const {
		type,
		onClick,
		onMouseEnter,
		style,
		size,
		className,
		id,
		loading,
		value,
		disabled,
		react_ref,
		hover_background,
		beta
	} = props;
	return (
		<StyledButton
			className={`${styles.button} ${styles['type-' + type]} ${styles['size-' + size]
				} ${className} focus:mu-outline-none focus:mu-shadow-ring`}
			{...{
				onClick,
				onMouseEnter,
				style,
				id,
				ref: react_ref,
				value,
				disabled: disabled || loading,
				hover_background,
			}}
		>
			{beta && <div className={`${styles.badge} ${classNames('flex-center bg-orange-500 transform -translate-y-full')}`} style={{ top: 10, right: 5 }}>Beta</div>}
			{loading ? <ButtonLoading {...props} /> : <ButtonText {...props} />}
		</StyledButton>
	);
};

const ButtonText = (props) => {
	const { text, icon, size, iconFirst } = props;
	return (
		<>
			{icon && iconFirst && <Icon className={text && 'mr-2'} icon={icon} size={iconSizes[size]} />}
			{text && <b>{text}</b>}
			{icon && !iconFirst && <Icon className={text && 'ml-2'} icon={icon} size={iconSizes[size]} />}
		</>
	);
};

const ButtonLoading = (props) => {
	const { text } = props;
	return (
		<div className={styles.loadingContainer}>
			<b>{text}</b>
			<Icon icon="spinner-third" className="absolute" spin />
		</div>
	);
};

Button.propTypes = {
	text: PropTypes.string.isRequired,
	size: PropTypes.string.isRequired,
	iconFirst: PropTypes.bool.isRequired,
	type: PropTypes.string.isRequired,
	style: PropTypes.object,
	className: PropTypes.string,
	loading: PropTypes.bool.isRequired,
};

Button.defaultProps = {
	type: 'primary',
	style: {},
	size: 'default',
	className: '',
	loading: false,
	text: '',
	id: '',
	iconFirst: true,
	onClick: undefined,
	onMouseEnter: undefined,
	value: null,
	disabled: false,
	react_ref: null,
};

export default Button;
